<onyx-section
  [heading]="`${I18N}.heading`"
  [count]="contactPersons()?.length ?? 0"
>
  <onyx-button
    options
    variant="outlined"
    [size]="32"
    leftIcon="add-outlined"
    (click)="addContactPerson()"
  >
    {{ 'labels.add' | translate }}
  </onyx-button>

  @if (contactPersons()?.length !== 0) {
    <div class="contact-wrapper">
      @for (contact of contactPersons(); track contact.email) {
        <onyx-data-preview heading="{{ contact | onyxName }}">
          @for (role of contact.roles; track role) {
            <onyx-badge left color="green">
              {{ `${DictionaryCode.EMPLOYEE_ROLE}.${role}` | translate }}
            </onyx-badge>
          }

          <div class="contact-info">
            <onyx-data-preview-item label="labels.workPhone">
              {{ contact.phone! | onyxPhone }}
            </onyx-data-preview-item>

            <onyx-data-preview-item label="labels.email">
              {{ contact.email }}
            </onyx-data-preview-item>

            @if (contact.transId) {
              <onyx-data-preview-item label="ID Trans">
                {{ contact.transId }}
              </onyx-data-preview-item>
            }
            @if (contact.timocomId) {
              <onyx-data-preview-item label="ID Timocom">
                {{ contact.timocomId }}
              </onyx-data-preview-item>
            }
            @if (contact.note) {
              <onyx-data-preview-item label="labels.note">
                {{ contact.note }}
              </onyx-data-preview-item>
            }
          </div>

          <div right class="buttons">
            <onyx-icon-button
              variant="transparent"
              color="black"
              [size]="24"
              icon="edit-outlined"
              (click)="editContactPerson($index)"
            ></onyx-icon-button>

            <onyx-icon-button
              variant="transparent"
              color="black"
              [size]="24"
              icon="delete-outlined"
              (click)="removeContactPerson($index)"
            ></onyx-icon-button>
          </div>
        </onyx-data-preview>
      }
    </div>
  }
</onyx-section>
